import { render, staticRenderFns } from "./CfSettings.vue?vue&type=template&id=78ffa4ac&scoped=true"
import script from "./CfSettings.vue?vue&type=script&lang=js"
export * from "./CfSettings.vue?vue&type=script&lang=js"
import style0 from "./CfSettings.vue?vue&type=style&index=0&id=78ffa4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ffa4ac",
  null
  
)

export default component.exports